import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";
import { RiListCheck3 } from "react-icons/ri";
import { TbTruckDelivery } from "react-icons/tb";
import { PiHandArrowDownDuotone } from "react-icons/pi";
import { FaRegEye } from "react-icons/fa";
import { MdOutlineCommentsDisabled } from "react-icons/md";
import { MdOutlineComment } from "react-icons/md";

//Srcs
import "../../Style/actionstyle.scss";
import Delete from "../Include/Delete";
import UpdateReqTakeOut from "./UpdateReqTakeOut";
import { DELETE_TAKE_OUT } from "../../Schema/TakeOut";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import CheckTakeOutMaterial from "./CheckTakeOutMaterial";
import DeliveryTakeOut from "./DeliveryTakeOut";
import ViewTakeOut from "./ViewTakeOut";
import VoidTakeOut from "./VoidTakeOut";
import RecieveTakeOut from "./RecieveTakeOut";

// 
export default function ReqTakeOutAction({ setRefetch, editData }) {
  // console.log("edeitef", editData);
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal check
  const [openCheck, setOpenCheck] = useState(false);
  const handleOpenCheck = () => setOpenCheck(true);
  const handleCloseCheck = () => setOpenCheck(false);

  //Modal delivery
  const [openDelivery, setOpenDelivery] = useState(false);
  const handleOpenDelivery = () => setOpenDelivery(true);
  const handleCloseDelivery = () => setOpenDelivery(false);
  //Modal recieve
  const [openRecieve, setOpenRecieve] = useState(false);
  const handleOpenRecieve = () => setOpenRecieve(true);
  const handleCloseRecieve = () => setOpenRecieve(false);
  //Modal view
  const [openViews, setOpenViews] = useState(false);
  const handleOpenViews = () => setOpenViews(true);
  const handleCloseViews = () => setOpenViews(false);
  //Modal void
  const [openVoid, setOpenVoid] = useState(false);
  const handleOpenVoid = () => setOpenVoid(true);
  const handleCloseVoid = () => setOpenVoid(false);

  //Modal reset
  const [openReset, setOpenReset] = useState(false);
  const handleOpenReset = () => setOpenReset(true);
  const handleCloseReset = () => setOpenReset(false);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [deleteReqTakeOut] = useMutation(DELETE_TAKE_OUT, {
    onCompleted: ({ deleteReqTakeOut }) => {
      // console.log("deleteReqTakeOut::", deleteReqTakeOut);
      setLoading(false);
      if (deleteReqTakeOut?.status === true) {
        setAlert(true, "success", deleteReqTakeOut?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteReqTakeOut?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteReqTakeOut({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {editData?.voidBy === null ? (
          editData?.status === "Approved" ? (
            <Tooltip title="ដឹកជញ្ជូន" placement="top">
              <IconButton onClick={handleOpenDelivery}>
                <Box className="apprv-container">
                  <TbTruckDelivery className="apprv-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          ) : editData?.status === "Delivery" ? (
            <Tooltip title="ទទួល" placement="top">
              <IconButton onClick={handleOpenRecieve}>
                <Box className="deliver-container">
                  <PiHandArrowDownDuotone className="deliver-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          ) : editData?.status === "Received" ||
            editData?.status === "Rejected" ? (
            <Tooltip title="មើលទិន្នន័យ" placement="top">
              <IconButton onClick={handleOpenViews}>
                <Box className="update-container">
                  <FaRegEye className="update-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="ពិនិត្យ" placement="top">
              <IconButton onClick={handleOpenCheck}>
                <Box className="check-container">
                  <RiListCheck3 className="check-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          )
        ) : (
          <Tooltip title="មើលទិន្នន័យ" placement="top">
            <IconButton onClick={handleOpenViews}>
              <Box className="update-container">
                <FaRegEye className="update-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
            onClick={handleOpenEdit}
            disabled={editData?.status !== "Pending"}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="ធ្វើមោឃៈ" placement="top">
          <IconButton
            onClick={handleOpenVoid}
            disabled={
              editData?.voidBy !== null || editData?.status === "Rejected"
            }
          >
            <Box className="delete-container">
              {editData?.voidBy === null ? (
                <MdOutlineComment className="delete-icon" />
              ) : (
                <MdOutlineCommentsDisabled className="delete-icon" />
              )}
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

    {
      openEdit && 
      <UpdateReqTakeOut
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
    }
      
    {
      openCheck && 
      <CheckTakeOutMaterial
        open={openCheck}
        handleClose={handleCloseCheck}
        editData={editData}
        setRefetch={setRefetch}
      />
    }
      
    {
      openDelivery && 
      <DeliveryTakeOut
        open={openDelivery}
        handleClose={handleCloseDelivery}
        editData={editData}
        setRefetch={setRefetch}
      />
    }
        

    {
      openRecieve && 
      <RecieveTakeOut
        open={openRecieve}
        handleClose={handleCloseRecieve}
        editData={editData}
        setRefetch={setRefetch}
      />
    }
      
    {
      openViews && 
      <ViewTakeOut
        open={openViews}
        handleClose={handleCloseViews}
        editData={editData}
        setRefetch={setRefetch}
      />
    }
      
    {
      openVoid && 
      <VoidTakeOut
        open={openVoid}
        handleClose={handleCloseVoid}
        editData={editData}
        setRefetch={setRefetch}
      />
    } 

      {/* <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"អ្នកផ្គត់ផ្គង"}
        loading={loading}
        handleDelete={handleDelete}
      /> */}
    </div>
  );
}
